export enum DueDateTo {
  Start = 'START',
  End = 'END',
  Now = 'DATE_NOW'
}

export enum PlusType {
  Days = 'DAYS',
  Months = 'MONTHS'
}

export const DUE_DATE_TO_OPTIONS = [
  { label: 'Start of next period', value: DueDateTo.Start },
  { label: 'End of next period', value: DueDateTo.End }
]

export const DUE_DATE_NOW_OPTION = { label: 'Now', value: DueDateTo.Now }

export const PLUS_TYPE_OPTIONS = [{ label: 'Days', value: PlusType.Days }, { label: 'Months', value: PlusType.Months }]
